export default {
    title: 'title',
    vat_id: 'VAT ID',
    cr_id: 'CR Number',
};
